<template>
  <div :class="{ 'form-group': !inline, 'form-check': inline }">
    <label class="form-label" :for="name" v-if="label">{{ label }}</label>
    <input
      :name="name"
      class="form-control"
      type="radio"
      value="value"
      @change="this.change"
      :checked="value === true"
    />
    <label class="form-check-label" :for="name" v-if="label">{{ label }}</label>
  </div>
</template>

<script>
export default {
  name: 'Radio',
  props: [
    'name',
    'value',
    'label',
  ],
  methods: {
    change(event) {
      this.$emit('input', event.target.checked);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
